"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitInfo = exports.SvgHead = exports.StyledTag = exports.InternalTag = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _ = require("../..");
var _breakpoints = _interopRequireDefault(require("../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const SvgHead = exports.SvgHead = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1awlddl3"
} : {
  target: "e1awlddl3",
  label: "SvgHead"
})("display:flex;justify-content:center;align-items:center;height:93px;margin:-10px -20px;margin-bottom:0;&>div{padding:5px 0;height:calc(100% - 10px);}@media screen and (max-width: ", _breakpoints.default.small, "){margin-top:-20px;}");
const UnitInfo = exports.UnitInfo = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1awlddl2"
} : {
  target: "e1awlddl2",
  label: "UnitInfo"
})(process.env.NODE_ENV === "production" ? {
  name: "1qc1gbv",
  styles: "padding-top:16px;&>h5{margin-bottom:4px;}>*{display:block;}"
} : {
  name: "1qc1gbv",
  styles: "padding-top:16px;&>h5{margin-bottom:4px;}>*{display:block;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const StyledTag = exports.StyledTag = /*#__PURE__*/(0, _base.default)(_.Tag, process.env.NODE_ENV === "production" ? {
  target: "e1awlddl1"
} : {
  target: "e1awlddl1",
  label: "StyledTag"
})(process.env.NODE_ENV === "production" ? {
  name: "16nq8y7",
  styles: "display:inline-block;margin-top:1.5em;font-size:12px;width:calc(100% - 16px);text-align:center;margin-bottom:-0.5em"
} : {
  name: "16nq8y7",
  styles: "display:inline-block;margin-top:1.5em;font-size:12px;width:calc(100% - 16px);text-align:center;margin-bottom:-0.5em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const InternalTag = exports.InternalTag = /*#__PURE__*/(0, _base.default)(_.Tag, process.env.NODE_ENV === "production" ? {
  target: "e1awlddl0"
} : {
  target: "e1awlddl0",
  label: "InternalTag"
})(process.env.NODE_ENV === "production" ? {
  name: "nd2ame",
  styles: "position:absolute;top:1rem;right:1rem"
} : {
  name: "nd2ame",
  styles: "position:absolute;top:1rem;right:1rem",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});